import { NormalTableRow, SmallContentTableRow, SmallTextTableRow } from "../Settings";
import SelectCell, { ISelectValue } from "./SelectCell";
import TextCell from "./TextCell";

interface ISelectRowProps {
    title: string,
    subtitle: string,
    label: string,
    active: boolean,
    colSpan: number,
    value: string | undefined,
    setValue: (value: string) => void,
    isMobile: boolean
    getEnumValuesAndKey: () => ISelectValue[],
}

const SelectRow: React.FC<ISelectRowProps> = (props) => {

    return (
        props.isMobile?
        <>
            <SmallTextTableRow>
                <TextCell colspan={3} title={props.title} subtitle={props.subtitle}/>
            </SmallTextTableRow>
            <SmallContentTableRow>
                <SelectCell
                    title={props.label}
                    colSpan={3}
                    active={props.active}
                    menuItems={props.getEnumValuesAndKey()}
                    value={props.value}
                    setValue={props.setValue}
                />
            </SmallContentTableRow>
        </>
        :
            <>
            <NormalTableRow>
                <TextCell title={props.title} subtitle={props.subtitle}/>
                <SelectCell
                    title={props.label}
                    colSpan={3}
                    active={props.active}
                    menuItems={props.getEnumValuesAndKey()}
                    value={props.value}
                    setValue={props.setValue}
                />
            </NormalTableRow>
            </>
    )
}

export default SelectRow